import { useCallback, useMemo, useState } from 'react'

import { type TeamMemberDto, TeamMemberRole } from '@api'
import type { Row } from '@tanstack/react-table'
import { useNavigate } from 'react-router-dom'

import EditIcon from '@/assets/icons/icon-edit.svg'
import RemoveIcon from '@/assets/icons/icon-trash.svg'
import { AppRoutes } from '@/utils/constants'

import { TeamRemoveDialog } from '../../dialogs/team-remove-dialog'

export interface TeamMemberActionsProps {
  row: Row<TeamMemberDto>
}

export const TeamMemberActions = ({ row }: TeamMemberActionsProps) => {
  const [showRemoveDialog, setRemoveEditDialog] = useState(false)

  const redirect = useNavigate()

  const openRemoveDialog = () => {
    setRemoveEditDialog(true)
  }

  const redirectToEditPage = useCallback(() => {
    redirect(AppRoutes.Teams.Members.Details.asUrl(String(row.original.id)))
  }, [redirect, row.original.id])

  const renderActionItems = useMemo(() => {
    // You can't edit the leader account on this page
    if (row.original.role === TeamMemberRole.LEADER) {
      return null
    }

    return (
      <div className="float-right flex gap-4">
        <button type="button">
          <EditIcon
            width={18}
            height={18}
            className="text-primary-500 hover:text-primary-800"
            onClick={redirectToEditPage}
          >
            Edit
          </EditIcon>
        </button>

        <button type="button">
          <RemoveIcon
            width={18}
            height={18}
            onClick={openRemoveDialog}
            className="text-danger-default hover:text-danger-dark"
          >
            Remove
          </RemoveIcon>
        </button>
      </div>
    )
  }, [redirectToEditPage, row.original.role])

  return (
    <>
      {renderActionItems}

      <TeamRemoveDialog
        row={row}
        setRemoveEditDialog={setRemoveEditDialog}
        showRemoveDialog={showRemoveDialog}
      />
    </>
  )
}
